import React, { useState } from 'react';
import FileSearch from './components/FileSearch';
import { Card, CardBody, Container } from 'reactstrap';
import FileTable from './components/FIleTable';

const fileMonitoringData = [
    {
     "tpa": "340B Direct",
     "inboundOutbound": "Inbound",
     "uploadStatus": "Uploaded",
     "uploadRetry": "-",
     "fileType": "Captured Claims",
     "fileName": "340bdirect_623246520221129180255286.txt",
     "recordCount": 2500,
     "createdDate": "11\/29\/2022",
     "modifiedDate": "11\/29\/2022",
     "fileID": "55995ac6-615e-40e1-b68c-9bda84d72271"
    },
    {
     "tpa": "Verity",
     "inboundOutbound": "Outbound",
     "uploadStatus": "Uploaded",
     "uploadRetry": "-",
     "fileType": "Response File",
     "fileName": "Verity__339904020221129175829482.850",
     "recordCount": 3651,
     "createdDate": "11\/29\/2022",
     "modifiedDate": "11\/29\/2022",
     "fileID": "d356a2ba-d7c5-40ff-8f0a-4908030ef466"
    },
    {
     "tpa": "Capture RX",
     "inboundOutbound": "Outbound",
     "uploadStatus": "Uploaded",
     "uploadRetry": "-",
     "fileType": "Replenished_Invoiced File",
     "fileName": "Capture RX_587592320221129175829530.txt",
     "recordCount": 789,
     "createdDate": "11\/29\/2022",
     "modifiedDate": "11\/29\/2022",
     "fileID": "083504d4-dfc6-4b1e-bc32-de9080acabbf"
    },
    {
     "tpa": "RX Stategies",
     "inboundOutbound": "Inbound",
     "uploadStatus": "Uploaded",
     "uploadRetry": "-",
     "fileType": "Captured Claims",
     "fileName": "RX Strategies_190351020221129175251746.txt",
     "recordCount": 152,
     "createdDate": "11\/29\/2022",
     "modifiedDate": "11\/29\/2022",
     "fileID": "ef291080-efc2-432b-ad0f-27cf316c0318"
    },
    {
     "tpa": "340B Direct",
     "inboundOutbound": "Outbound",
     "uploadStatus": "Uploaded",
     "uploadRetry": "-",
     "fileType": "Response File",
     "fileName": "340Bdirect_246168020221129174801566.txt",
     "recordCount": 1986,
     "createdDate": "11\/29\/2022",
     "modifiedDate": "11\/29\/2022",
     "fileID": "8ec66cb4-8eeb-459d-9eb4-92860509ef08"
    },
    {
     "tpa": "Verity",
     "inboundOutbound": "Outbound",
     "uploadStatus": "Uploaded",
     "uploadRetry": "-",
     "fileType": "Replenished_Invoiced File",
     "fileName": "Verity_840315620221129173824533.txt",
     "recordCount": 1084,
     "createdDate": "11\/29\/2022",
     "modifiedDate": "11\/29\/2022",
     "fileID": "974dc171-31f1-4f3c-bf2b-454074d018e0"
    },
    {
     "tpa": "Capture RX",
     "inboundOutbound": "Inbound",
     "uploadStatus": "Uploaded",
     "uploadRetry": 2,
     "fileType": "Captured Claims",
     "fileName": "PharmaForce_Mck_850_353288520221129173824511.txt",
     "recordCount": 635,
     "createdDate": "11\/29\/2022",
     "modifiedDate": "11\/29\/2022",
     "fileID": "ba5cd23e-421e-42c8-974a-65b33397ff0d"
    },
    {
     "tpa": "RX Stategies",
     "inboundOutbound": "Outbound",
     "uploadStatus": "Uploaded",
     "uploadRetry": 1,
     "fileType": "Response File",
     "fileName": "Cardinal_Response File_631755520221129172750954.txt",
     "recordCount": 218,
     "createdDate": "11\/29\/2022",
     "modifiedDate": "11\/29\/2022",
     "fileID": "e78eb698-1233-46f0-9ab9-3950b452fba2"
    },
    {
     "tpa": "340B Direct",
     "inboundOutbound": "Outbound",
     "uploadStatus": "Uploaded",
     "uploadRetry": "-",
     "fileType": "Replenished_Invoiced File",
     "fileName": "Cardinal_Replenished_Invoiced File_991504920221129172258970.txt",
     "recordCount": 4127,
     "createdDate": "11\/29\/2022",
     "modifiedDate": "11\/29\/2022",
     "fileID": "b25da1f7-1fea-4cb8-880c-6ee4fc389de9"
    }
   ]

const FileMonitoring = () => {
    const [state, updateState] = useState({
        data: [],
        records: 0,
        currentPage: 1,
        pageSize: 10,
        loading: false,
      });
    
      const { data, loading, currentPage, pageSize, records } = state;
    
      const onSearch = () => {
        setState({ loading: true });
        setTimeout(() => {
          let splicedData = [...fileMonitoringData].slice(
            currentPage === 1 ? 0 : currentPage * pageSize,
            pageSize
          );
          setState({
            loading: false,
            data: splicedData,
            records: fileMonitoringData.length,
          });
        }, 1000);
      };
    
      const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));
    
      const onPageChange = ({ currentPage: page }) => {
        setState({ loading: true });
        setTimeout(() => {
          let splicedData = [...fileMonitoringData].slice(
            page === 1 ? 0 : page * pageSize,
            pageSize * (page + 1)
          );
          setState({
            loading: false,
            data: splicedData,
            records: fileMonitoringData.length,
            currentPage: page,
          });
        }, 1000);
      };

      const onReset = () => {
        setState({ data: [] });
      };
    
      const onPageSizeChange = ({ pageSize }) => {
        setState({ loading: true });
        setTimeout(() => {
          let splicedData = [...fileMonitoringData].slice(0, pageSize);
          setState({
            pageSize,
            currentPage: 1,
            data: splicedData,
            loading: false,
          });
        }, 600);
      };
      return (
        <div>
          <Container fluid className="my-3">
            <Card className="border-0 shadow-top">
              <CardBody className="section-devider-border">
                <FileSearch onSearch={onSearch} onReset={onReset}/>
              </CardBody>
              <CardBody>
                <FileTable
                  loading={loading}
                  pageSize={pageSize}
                  currentPage={currentPage}
                  records={records}
                  onPageChange={onPageChange}
                  onPageSizeChange={onPageSizeChange}
                  data={data}
                />
              </CardBody>
            </Card>
          </Container>
        </div>
      );
}

export default FileMonitoring;